var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/opt/build/repo/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("react"), require("styled-components"));else if ("function" == typeof define && define.amd) define(["react", "styled-components"], t);else {
    var o = "object" == typeof exports ? t(require("react"), require("styled-components")) : t(e.react, e[void 0]);

    for (var r in o) {
      ("object" == typeof exports ? exports : e)[r] = o[r];
    }
  }
}(this, function (e, t) {
  return function () {
    "use strict";

    var o = {
      232: function _(e, t, o) {
        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.ImageViewer = void 0;
        var n = r(o(156)),
            i = o(964),
            a = o(840),
            l = o(585);

        t.ImageViewer = function (e) {
          var _ref = (0, l.useViewer)(),
              t = _ref.dontClose,
              o = _ref.closeViewer,
              r = _ref.show,
              s = _ref.showViewer;

          return n.default.createElement(n.default.Fragment, null, n.default.createElement(a.ImageBody, {
            onClick: s
          }, e.children), r && n.default.createElement(a.ViewerFrame, {
            onClick: o
          }, n.default.createElement(a.CloseBtn, {
            onClick: o
          }, n.default.createElement(i.CloseIcon, null)), n.default.createElement(a.ImageContainer, {
            onClick: t
          }, e.children)));
        };
      },
      964: function _(e, t, o) {
        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.CloseIcon = void 0;
        var n = r(o(156)),
            i = r(o(466)),
            a = i.default.svg.attrs({
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          xmlnsXlink: "http://www.w3.org/1999/xlink"
        })(_templateObject || (_templateObject = _taggedTemplateLiteral([""]))),
            l = (0, i.default)(a)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 25px;\n  height: 25px;\n"])));

        t.CloseIcon = function () {
          return n.default.createElement(l, {
            viewBox: "0 0 100 100",
            fill: "#fff"
          }, n.default.createElement("path", {
            d: "M89.7,10.3L89.7,10.3c-1-1-2.6-1-3.5,0L50,46.5L13.9,10.3c-1-1-2.6-1-3.5,0l0,0c-1,1-1,2.6,0,3.5L46.5,50L10.3,86.1\r\n      c-1,1-1,2.6,0,3.5h0c1,1,2.6,1,3.5,0L50,53.5l36.1,36.1c1,1,2.6,1,3.5,0l0,0c1-1,1-2.6,0-3.5L53.5,50l36.1-36.1\r\n      C90.6,12.9,90.6,11.3,89.7,10.3z"
          }));
        };
      },
      840: function _(e, t, o) {
        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.ImageContainer = t.CloseBtn = t.ViewerFrame = t.ImageBody = void 0;
        var n = r(o(466));
        t.ImageBody = n.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  &:hover {\n    cursor: pointer;\n  }\n"]))), t.ViewerFrame = n.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: 1000;\n  padding-top: 10px;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: rgba(0, 0, 0, 0.9);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  \n  img {\n    all: unset;\n    width: 100%;\n    max-width: 1250px;\n    height: 100%;\n    max-height: 90vh;\n    animation-name: zoom;\n    animation-duration: 0.5s;\n  }\n  \n  @keyframes zoom {\n    from {\n      transform: scale(0)\n    }\n    to {\n      transform: scale(1)\n    }\n  }\n"]))), t.CloseBtn = n.default.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  position: absolute;\n  z-index: 1001;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  right: 0;\n  top: 0;\n  margin: 20px;\n  width: 40px;\n  height: 40px;\n  background-color: #000;\n  border-radius: 50%;\n  animation-name: zoom;\n  animation-duration: 0.5s;\n"]))), t.ImageContainer = n.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  padding: 0px 20px;\n"])));
      },
      585: function _(e, t, o) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.useViewer = void 0;
        var r = o(156);

        t.useViewer = function () {
          var _ref2 = (0, r.useState)(!1),
              _ref3 = _slicedToArray(_ref2, 2),
              e = _ref3[0],
              t = _ref3[1],
              o = function o() {
            t(!1);
          };

          return (0, r.useEffect)(function () {
            document.addEventListener("keyup", function (e) {
              27 === e.keyCode && o();
            }), document.body.style.overflow = !0 === e ? "hidden" : "";
          }, [e]), {
            show: e,
            showViewer: function showViewer() {
              t(!0);
            },
            dontClose: function dontClose(e) {
              e.stopPropagation();
            },
            closeViewer: o
          };
        };
      },
      156: function _(t) {
        t.exports = e;
      },
      466: function _(e) {
        e.exports = t;
      }
    },
        r = {};

    function n(e) {
      var t = r[e];
      if (void 0 !== t) return t.exports;
      var i = r[e] = {
        exports: {}
      };
      return o[e].call(i.exports, i, i.exports, n), i.exports;
    }

    var i = {};
    return function () {
      var e = i;
      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.ImageViewer = void 0;
      var t = n(232);
      Object.defineProperty(e, "ImageViewer", {
        enumerable: !0,
        get: function get() {
          return t.ImageViewer;
        }
      });
    }(), i;
  }();
});